import { inject, Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable, shareReplay } from 'rxjs';
import { UserEntitlements } from '../components/user-details/models/entitlements';
import { environment } from '../../../../../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class EntitlementsService {
  private http = inject(HttpClient);
  private userPermissions$: Observable<UserEntitlements> | null = null;

  getEntitlements(): Observable<UserEntitlements> {
    if (!this.userPermissions$) {
      this.userPermissions$ = this.http
        .get<UserEntitlements>(`${environment.apiUrl}/users/entitlements`)
        .pipe(shareReplay(1));
    }
    return this.userPermissions$;
  }
}
